enum AccessOverviewEditChartColorsElementEnum {
  WithColor = "withColor",
  WithoutColor = "withoutColor",
  ExcludedColor = "excludedColor",
  ProviderOne = "providerOne",
  ProviderOneColor = "providerOneColor",
  ProviderTwo = "providerTwo",
  ProviderTwoColor = "providerTwoColor",
  ProviderThree = "providerThree",
  ProviderThreeColor = "providerThreeColor",
  ProviderFour = "providerFour",
  ProviderFourColor = "providerFourColor",
  ProviderFive = "providerFive",
  ProviderFiveColor = "providerFiveColor",
  GraphMiles = "graphMiles",
  ShowMinimums = "showMinimums",
  ShowMaximums = "showMaximums",
}

export { AccessOverviewEditChartColorsElementEnum };
